var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _circle, _circle2, _circle3, _path14, _path15, _path16, _path17, _path18, _circle4, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgManWithProgressBlueIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 90,
  height: 90,
  "data-name": "Layer 1",
  viewBox: "0 0 955.953 639.224"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M.3.399h703.576V451H.3z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M20.419 56.915h663.339v171.773H20.419z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M185.418 81.727h140.281v8.053H185.418z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#004c77",
  d: "M185.418 111.101h216.625v8.053H185.418z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M185.418 138.776h176.544v8.053H185.418zM185.418 166.346h103.064v8.053H185.418zM185.418 193.916h155.55v8.053h-155.55zM121.481 78.864h17.177v17.177h-17.177z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#004c77",
  d: "M121.481 106.539h17.177v17.177h-17.177z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M121.481 134.213h17.177v17.177h-17.177zM121.481 161.888h17.177v17.177h-17.177zM121.481 189.562h17.177v17.177h-17.177zM533.736 117.99h57.258v57.258h-57.258z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M20.419 252.546h663.339v171.773H20.419z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M151.064 267.812h17.177v17.177h-17.177z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#004c77",
  d: "M121.481 267.812h17.177v17.177h-17.177z"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M412.724 305.375a65.046 65.046 0 0 0-105.003-9.7l-4.186-3.657a70.594 70.594 0 0 1 113.973 10.526Z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#004c77",
  d: "m415.344 377.794-4.614-3.102a65.08 65.08 0 0 0 1.994-69.317l4.784-2.831a70.64 70.64 0 0 1-2.164 75.25M304.114 385.539a70.59 70.59 0 0 1-.58-93.521l4.187 3.657a65.03 65.03 0 0 0 .534 86.155Z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#004c77",
  d: "M356.714 409.052a70.7 70.7 0 0 1-52.6-23.513l4.14-3.71a65.043 65.043 0 0 0 102.476-7.137l4.614 3.102a70.55 70.55 0 0 1-58.63 31.258"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#e6e6e6",
  d: "M533.736 305.032h57.258v57.258h-57.258zM119.095 342.249h57.258v57.258h-57.258z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#004c77",
  d: "M0 0h703.576v29.89H0z"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 22.212,
  cy: 15.282,
  r: 5.54,
  fill: "#fff"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 43.241,
  cy: 15.282,
  r: 5.54,
  fill: "#fff"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 64.269,
  cy: 15.282,
  r: 5.54,
  fill: "#fff"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb8b8",
  d: "M817.168 623.704h14.243l6.777-54.94-21.023.001z"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "m813.535 619.054 28.05-.001h.002a17.877 17.877 0 0 1 17.876 17.876v.58l-45.928.002Z"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#ffb8b8",
  d: "m781.694 569.766 10.511 9.613 42.079-35.968-15.513-14.187z"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "m782.152 563.883 20.7 18.93a17.877 17.877 0 0 1 1.127 25.256l-.392.429-33.892-30.995ZM839.555 430.772l-4.037 80.739 10.093 87.805-30.278 4.037-19.175-111.017-6.056-75.694z"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "M886.99 401.504s12.11 79.73-13.12 105.97-59.546 72.666-59.546 72.666l-24.222-30.277 61.564-65.601-12.11-44.407-49.454-23.213 8.074-55.508 72.666-1.01Z"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 831.415,
  cy: 192.095,
  r: 24.717,
  fill: "#ffb8b8"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "m851.917 227.224 3.786 5.736 10.093 28.259-8.074 110.007-47.435 1.01-6.055-126.156 12.685-15.856z"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "m785.056 249.108-8.074-1.01s-2.018 1.01-3.028 8.075-13.12 69.637-13.12 69.637l16.148 76.703 18.166-24.222-11.101-42.388 11.102-42.388ZM887.999 248.099h6.055l15.139 81.748-14.129 63.583-14.13-23.213 4.037-25.231-2.018-22.203-7.065-13.121zM846.021 192.095l-4.494-1.124s-3.37-19.1-11.235-16.853-28.088 4.494-28.088-4.494 19.1-16.853 30.335-15.73 25.584 4.852 29.212 21.348c5.814 26.444-11.997 33.123-11.997 33.123l.296-.963a15 15 0 0 0-4.029-15.307"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#2f2e41",
  d: "m777.991 248.099 32.296-13.12 7.57-5.551 22.708 100.42 15.138-45.417-4.541-58.031 41.883 21.699-14.13 68.628-2.018 26.24 6.056 21.195s21.194 15.138 14.13 31.286-15.14 17.157-15.14 17.157-34.314-32.295-36.332-40.37-5.046-22.203-5.046-22.203-17.158 64.592-37.342 63.583-20.185-22.204-20.185-22.204l5.046-22.203 8.074-23.213-4.037-38.351Z"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M954.953 639.224h-268a1 1 0 0 1 0-2h268a1 1 0 0 1 0 2"
})));
export default SvgManWithProgressBlueIcon;